jQuery(document).ready(function ($) {
    let widget = $('.review-widget_net');

    widget.each(function (event) {
        let _this = $(this);

        const config = { childList: true };

        function callback(mutationList, observer) {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {

                    // remove branding
                    _this.find('.branding').attr('style', 'display: none !important;').remove();

                }
            }
        }

        const observer = new MutationObserver(callback);
        observer.observe(_this.get(0), config);
    });
});